import React from "react"

import ingeteamev from "../../../data/home/ingeteamev/imageSliderData.json"
import { getCmsAssetsUrl } from "../../../helpers/general"
import { getSiteConfig } from "../../../hooks/use-site-config"
import TwoColumnSlider from "../../TwoColumnSlider/TwoColumnSlider"

import styles from "./imageSlider.module.scss"

const assetsUrl = getCmsAssetsUrl()

const ImageSlider = () => {
  const slidersMap = {
    ingeteamev: ingeteamev,
  }
  const site = getSiteConfig()
  const slides = slidersMap[site.code].map(s => ({
    ...s,
    imageSrc: s.imageSrc.replace(/^\/data/, assetsUrl),
  }))
  return (
    <div className={styles.wrapper}>
      <TwoColumnSlider
        slides={slides}
        autoplay={true}
        autoplayInterval={4000}
        pauseOnInteractionDuration={10000}
      />
    </div>
  )
}

export default ImageSlider
